<template>
  <div class="height100">
    <div class="transition-text" :class="{'hidden-animated': transitionEnds}">
      <div class="text" v-if="this.html" v-html="this.html"></div>
      <div class="text" v-else>{{text}}</div>
    </div>

    <PageContainer :class="{'hidden': !contentLoaded}">
      <slot></slot>
    </PageContainer>
  </div>
</template>

<script>
import $ from 'jquery';
import PageContainer from '../../shared/components/PageContainer';

export default {
  components: {
    PageContainer
  },
  props: ['text', 'fast', 'faster', 'slow', 'slower', 'html', 'contentLoadedFunc'],
  data() {
    return {
      transitionEnds: false,
      contentLoaded: false
    }
  },
  mounted() {
    if (!this.text && !this.html) {
      this.transitionEnds = true;
      this.contentLoaded = true;
    } else {
      setTimeout(() => {
        this.transitionEnds = true;
      }, this.getTimeout1());
      setTimeout(() => {
        this.contentLoaded = true;
        if (this.contentLoadedFunc && $.isFunction(this.contentLoadedFunc)) this.contentLoadedFunc();
      }, this.getTimeout2());
    }
  },
  methods: {
    getTimeout1: function () {
      let timeout1 = 2000;
      if (this.fast) timeout1 = 1500;
      if (this.faster) timeout1 = 1000;
      if (this.slow) timeout1 = 2500;
      if (this.slower) timeout1 = 3000;
      return timeout1;
    },
    getTimeout2: function () {
      let timeout2 = 3000;
      if (this.fast) timeout2 = 2000;
      if (this.faster) timeout2 = 1500;
      if (this.slow) timeout2 = 3000;
      if (this.slower) timeout2 = 3500;
      return timeout2;
    }
  }
}
</script>
